import { BASE_URL, COMPANY_PROFICIENCY_LEVELS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ICompanyProficiencyLevels, ICompanyProficiencyLevelsInput } from "models/companyProficiencyLevels";

export async function getCompanyProficiencyLevels(params: string = ""): Promise<ICompanyProficiencyLevels[]> {
  const response = await axios.get(
    BASE_URL + COMPANY_PROFICIENCY_LEVELS + params
  );
  return response.data;
}

export async function addCompanyProficiencyLevel(
  data: ICompanyProficiencyLevelsInput
) {
  const response = await axios.post(
    BASE_URL + COMPANY_PROFICIENCY_LEVELS,
    data
  );
  return response.data;
}
export async function editCompanyProficiencyLevel(
  data: ICompanyProficiencyLevelsInput,
  id: string
) {
  const response = await axios.patch(
    BASE_URL + COMPANY_PROFICIENCY_LEVELS + "/" + id,
    data
  );
  return response.data;
}

export async function deleteCompanyProficiencyLevel(id: string) {
  const response = await axios.delete(
    BASE_URL + COMPANY_PROFICIENCY_LEVELS + "/" + id
  );
  return response.data;
}

export const CompanyProficiencyLevelsCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  {
    id: "rank",
    numeric: false,
    disablePadding: false,
    label: "T_rank",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
